<div class="calendar-dialog">
  <div class="calendar-dialog-title">
    <h1 mat-dialog-title>Need to swap your days?</h1>
  </div>
  <mat-dialog-content>{{data.body}}</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close class="close-btn">Close</button>
    <button mat-raised-button color="primary" mat-dialog-close="add service">Add service</button>
  </mat-dialog-actions>
</div>